export enum POP_WIDTH_UNIT {
    PX = 'px',
    EM = 'em',
    REM = 'rem',
    PERCENTAGE = '%'
}
